import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a3aa9e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "incredicon-edit-table !text-[20px] mr-2" }, null, -1))
const _hoisted_2 = ["data-testid"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-b-System/app_border bg-System/app_white sticky top-0" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-gordita-medium text-[14px] leading-[19px] py-[11px] px-[16px]" }, "Manage Columns")
], -1))
const _hoisted_4 = { class: "flex items-center h-[32px]" }
const _hoisted_5 = { class: "ml-[3px] text-Text/text_low" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uis uis-padlock text-[16px] ml-auto" }, null, -1))
const _hoisted_7 = { class: "flex w-full" }
const _hoisted_8 = { class: "flex grow flex-wrap items-center h-[32px]" }
const _hoisted_9 = ["data-testid"]
const _hoisted_10 = { class: "flex flex-wrap items-center h-[32px]" }
const _hoisted_11 = {
  key: 0,
  class: "mr-1.5 bg-Hovers/app_hover_violet rounded-sm px-[2px] text-Brand/violet flex items-center justify-center"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gordita-500-11" }, "Cloud", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "w-[15px]" }
const _hoisted_15 = {
  key: 0,
  class: "ml-auto cursor-grab active:cursor-grabbing text-Text/text_lowest text-[15px] leading-[20px] uil uil-draggabledots handle",
  "data-testid": "manage-columns--drag-handle"
}
const _hoisted_16 = { class: "border-t border-t-System/app_border" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Reset to Default", -1))

import { computed, inject, ref, watch } from 'vue';
import { IncrediButton, IncrediCard, IncrediCheckbox, IncrediDraggableList, IncrediField, IncrediItem, IncrediList, IncrediMenu } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import elementIds from '@/const/elementIds.json';
import { useAgentsColumnsManagement } from '@/views/agents/agents.helpers';
import { useMatomo } from '@/services/matomo/matomo.service';
import { MatomoAgentsActions, MatomoCategories } from '@/services/matomo/matomo.const';
import { useOsService } from '@/services/OsService/OsService';
import { Agent_SortField, Agent_SortOrder } from '@/graphql/codegen/generated/graphql';
import { useAgentsTableUtils } from '@/views/agents/components/agents-table/agent-table-list/OS/agents-table.utils';
import type { columnOrder } from './edit-table.types';
import { useAgentsTableConstants } from '../agents-table/agents-table.const';
import { ColumnsFilter, TableColumn, TableEditorUnified } from '../agents-table/types/agents-table.types';
import { IKAgentsQueryFilter } from '../../agents.injectionKeys';


export default /*#__PURE__*/_defineComponent({
  __name: 'edit-table',
  setup(__props) {

const osService = useOsService();
const { isCloudActivated, isCloudColumn } = useAgentsTableUtils();
const agentsTableConstants = useAgentsTableConstants();
const agentsQueryFilter = inject(IKAgentsQueryFilter);
const matomo = useMatomo();
const unSelectedDirtyColumns = ref<columnOrder[]>([]);
const tableData = useAgentsColumnsManagement();
const editTable = tableData?.tableEditor as TableEditorUnified;
const menu = ref(false);
const searchColumns = ref('');
const searchColumnsInputFocused = ref(false);

const handleColumnSelection = (column: TableColumn) => {
  const isSelected = !editTable?.get[osService.osType.value].value.columnsFilter[column.name];
  matomo?.trackEvent({
    category: MatomoCategories.Agents,
    action: MatomoAgentsActions.ColumnSelection,
    name: column.name,
    value: isSelected ? 1 : 0,
  });

  const defaultColumnData = agentsTableConstants.columns.value.filter(defaultCol => defaultCol.name === column.name)[0];
  if (editTable) {
    const { columnsOrder } = editTable.get[osService.osType.value].value;
    editTable.set[osService.osType.value]({
      // Set default column's width to default for both actions: select and unselect
      columnsOrder: [...columnsOrder.filter(orderedColumn => orderedColumn.name !== column.name), { ...column, width: defaultColumnData.width }],
      columnsFilter: { ...editTable.get[osService.osType.value].value.columnsFilter, [column.name]: isSelected },
    });
  }

  if (isSelected) {
    unSelectedDirtyColumns.value = unSelectedDirtyColumns.value.filter(dirtyColumn => dirtyColumn.name !== column.name);
  } else {
    if (agentsTableConstants.mapColumnsToAgentSortField.value[column.name as keyof typeof agentsTableConstants['mapColumnsToAgentSortField']['value']] === agentsQueryFilter?.get.value.sort.field) {
      agentsQueryFilter?.set({
        ...agentsQueryFilter?.get.value,
        sort: {
          ...agentsQueryFilter?.get.value.sort,
          field: Agent_SortField.Name,
          order: Agent_SortOrder.Ascending,
        },
      });
    }
    unSelectedDirtyColumns.value.unshift(column);
  }
};

const columnsManagementMenuHandler = (isOpen: boolean) => {
  menu.value = isOpen;
  unSelectedDirtyColumns.value = [];
};

const isContainingCloudColumns = () => editTable?.get[osService.osType.value].value.columnsOrder.some((column: any) => isCloudColumn(column.name));
const removeCloudColumns = () => {
  // remove cloud columns from columns filter
  const columnsFilter = editTable?.get[osService.osType.value].value.columnsFilter || {};
  Object.keys(columnsFilter).forEach((column: any) => {
    if (isCloudColumn(column)) {
      delete (columnsFilter as any)[column];
    }
  });

  (editTable as any).set[osService.osType.value]({
    columnsOrder: editTable?.get[osService.osType.value].value.columnsOrder.filter(column => !isCloudColumn(column.name)),
    columnsFilter: columnsFilter as ColumnsFilter,
  });
};

const addCloudColumnsToColumns = () => {
  const cloudColumns = agentsTableConstants.columns.value.filter(column => isCloudColumn(column.name));
  const columnsOrder = [...Object.values(editTable?.get[osService.osType.value].value.columnsOrder as any), ...cloudColumns];
  const columnsFilter = { ...editTable?.get[osService.osType.value].value.columnsFilter, ...cloudColumns.reduce((acc, cur) => ({ ...acc, [cur.name]: false }), {}) } as ColumnsFilter;
  // add to columnFilter and columnsOrder
  (editTable as any).set[osService.osType.value]({
    columnsOrder,
    columnsFilter,
  });
};

const handleCloudColumns = (cloudValue: boolean | null | undefined) => {
  if (cloudValue) {
    if (!isContainingCloudColumns()) {
      addCloudColumnsToColumns();
    }
  } else removeCloudColumns();
};

// Method to rest columns data to their default values
const resetToDefault = () => {
  tableData?.resetColumnsToDefault();
  handleCloudColumns(isCloudActivated.value);
  unSelectedDirtyColumns.value = [];
  matomo?.trackEvent({
    category: MatomoCategories.Agents,
    action: MatomoAgentsActions.ColumnSelectionReset,
  });
};
const lockedColumns = computed(() =>
  editTable?.get[osService.osType.value].value.columnsOrder.filter(column => column.locked && column.name.toLowerCase().includes(searchColumns.value.toLowerCase())),
);
const handleDragColumn = (columnsOrder: NonNullable<typeof editTable>['get']['windows']['value']['columnsOrder'] | NonNullable<typeof editTable>['get']['linux']['value']['columnsOrder']) => {
  if (editTable)
    editTable.set[osService.osType.value]({
      ...editTable.get[osService.osType.value].value,
      columnsOrder: [...editTable.get[osService.osType.value].value.columnsOrder.filter(column => column.locked), ...columnsOrder],
    });
};

const columnsOrder = computed(() => {
  const selectedColumns = editTable?.get[osService.osType.value].value.columnsOrder?.filter(column => editTable?.get[osService.osType.value].value.columnsFilter[column.name]);
  const unSelectedColumns = editTable?.get[osService.osType.value].value.columnsOrder
    .filter(column => !unSelectedDirtyColumns.value.find(dirtyColumn => dirtyColumn.name === column.name) && !editTable?.get[osService.osType.value].value.columnsFilter[column.name])
    .sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
  return [...(selectedColumns || []), ...unSelectedDirtyColumns.value, ...(unSelectedColumns || [])].filter(
    column => !column.locked && column.name.toLowerCase().includes(searchColumns.value.toLowerCase()),
  );
});

watch(
  () => menu.value,
  newValue => {
    if (!newValue) {
      searchColumns.value = '';
    }
  },
);

watch(
  () => isCloudActivated.value,
  newValue => {
    handleCloudColumns(newValue);
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(IncrediMenu), {
      "model-value": menu.value,
      direction: 'bottom-sticky-right',
      "offset-y": 4,
      "onUpdate:modelValue": columnsManagementMenuHandler
    }, {
      content: _withCtx(() => [
        _createVNode(IbxScopedCss, null, {
          default: _withCtx(() => [
            _createVNode(_unref(IncrediCard), {
              class: "w-[280px] rounded-[2px]",
              "data-testid": _unref(elementIds).agents.manageColumnsList
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(_unref(IncrediField), {
                  modelValue: searchColumns.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchColumns).value = $event)),
                  class: _normalizeClass(["my-2 mx-1", [searchColumns.value ? 'text-Text/text_high' : 'text-Text/text_low']]),
                  "data-testid": _unref(elementIds).agents.AgentsSortByMenuSearchInput,
                  name: "search",
                  label: "Search",
                  size: "tiny",
                  clearable: "",
                  onFocusWithin: _cache[1] || (_cache[1] = ($event: any) => (searchColumnsInputFocused.value = true)),
                  onBlurWithin: _cache[2] || (_cache[2] = ($event: any) => (searchColumnsInputFocused.value = false))
                }, {
                  prepend: _withCtx(() => [
                    _createElementVNode("i", {
                      class: _normalizeClass(["uil uil-search text-[20px] mr-[10px]", [searchColumnsInputFocused.value ? 'text-System/app_primary' : 'text-Text/text_low']])
                    }, null, 2)
                  ]),
                  _: 1
                }, 8, ["modelValue", "class", "data-testid"]),
                _createVNode(_unref(IncrediList), { class: "!shadow-none overflow-auto max-h-[34vh] mb-[3px] !pt-0" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lockedColumns), (lockedColumn, index) => {
                      return (_openBlock(), _createBlock(_unref(IncrediItem), {
                        key: index,
                        style: {"padding-top":"0px","padding-bottom":"0px"},
                        class: "cursor-default py-0 !px-[4px]",
                        disabled: "",
                        "data-testid": "locked-column"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_unref(IncrediCheckbox), {
                              "data-checkbox-id": lockedColumn.name,
                              disabled: "",
                              size: "small",
                              design: 'primary-green',
                              "model-value": true
                            }, null, 8, ["data-checkbox-id"]),
                            _createElementVNode("span", _hoisted_5, _toDisplayString(lockedColumn.name), 1),
                            _hoisted_6
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    _createVNode(_unref(IncrediDraggableList), {
                      "model-value": _unref(columnsOrder) as any,
                      "item-key": "name",
                      handle: ".handle",
                      "onUpdate:modelValue": handleDragColumn
                    }, {
                      item: _withCtx(({ item: column }: { item: TableColumn }) => [
                        _createVNode(_unref(IncrediItem), {
                          class: "incredi-item--container py-0 !px-[4px]",
                          style: {"padding-top":"0px","padding-bottom":"0px"},
                          "data-testid": `item-row-${column.name}`
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, [
                                _createVNode(_unref(IncrediCheckbox), {
                                  "data-checkbox-id": column.name,
                                  size: "small",
                                  design: 'primary-green',
                                  "model-value": !!(_unref(editTable)?.get[_unref(osService).osType.value].value.columnsFilter as ColumnsFilter)[column.name],
                                  onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                                  "onUpdate:modelValue": (val) => handleColumnSelection(column)
                                }, null, 8, ["data-checkbox-id", "model-value", "onUpdate:modelValue"]),
                                _createElementVNode("span", {
                                  "data-testid": column.name,
                                  class: "ml-[3px] select-none"
                                }, _toDisplayString(column.name), 9, _hoisted_9)
                              ]),
                              _createElementVNode("div", _hoisted_10, [
                                (_unref(isCloudColumn)(column.name))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_14, [
                                  ((_unref(editTable)?.get[_unref(osService).osType.value].value.columnsFilter as ColumnsFilter)[column.name] && !searchColumns.value)
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_15))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["data-testid"])
                      ]),
                      _: 1
                    }, 8, ["model-value"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_unref(IncrediButton), {
                    "data-testid": "reset-to-default-button",
                    class: "p-[8px] reset-button",
                    design: "ghost-green",
                    size: "tiny",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (resetToDefault()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["data-testid"])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(IncrediButton), {
          class: "whitespace-nowrap flex flex-nowrap items-center !text-Text/text_high edit-table--button radius-[2px] !px-[4px]",
          design: "master",
          size: "small",
          selected: menu.value
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("span", {
              class: "text-[12px]",
              "data-testid": _unref(elementIds).agents.manageColumnsButton
            }, " Manage Columns ", 8, _hoisted_2)
          ]),
          _: 1
        }, 8, ["selected"])
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})